import { setCookie } from './functions.js';
import { getCookie } from './functions.js';
import { getUrlParameter } from './functions.js';
import { openModal } from './functions.js';
import { imageSrc } from './functions.js';

//
// Lazyload videos
//
function lazyLoadVideos() {
	// Get all the images with the "data-src" attribute
	const images = document.querySelectorAll('video.lazy-video');

	// Specify the distance below the viewport to load the images (in pixels)
	const distanceBelowViewport = window.innerHeight * 0.5;

	// Configure the Intersection Observer
	const config = {
		rootMargin: `0px 0px ${distanceBelowViewport}px 0px`,
		// threshold: 0 // Adjust the threshold as needed
	};

	// Create a new Intersection Observer
	const observer = new IntersectionObserver((entries, observer) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				const video = entry.target;
				// Check if the video has the autoplay attribute
				const shouldAutoplay = video.hasAttribute('autoplay');
				for (var source in video.children) {
					var videoSource = video.children[source];
					if (
						typeof videoSource.tagName === 'string' &&
						videoSource.tagName === 'SOURCE'
					) {
						videoSource.src = videoSource.dataset.src;
						videoSource.removeAttribute('data-src');
					}
				}
				video.load();
				// Only play the video if it has autoplay attribute
				if (shouldAutoplay) {
					video.play();
				}
				video.classList.remove('lazy-video');

				// Stop observing the current video
				observer.unobserve(video);
			}
		});
	}, config);

	// Start observing each image
	images.forEach((image) => {
		observer.observe(image);
	});
}
// document.addEventListener("DOMContentLoaded", lazyLoadVideos);
window.addEventListener('load', lazyLoadVideos);

//
// Lazy load images
//
function lazyLoadImages() {
	// Get all the images with the "data-src" attribute
	const images = document.querySelectorAll('img[data-src]');

	// Specify the distance below the viewport to load the images (in pixels)
	const distanceBelowViewport = window.innerHeight * 0.5;

	// Configure the Intersection Observer
	const config = {
		rootMargin: `0px 0px ${distanceBelowViewport}px 0px`,
		// threshold: 0 // Adjust the threshold as needed
	};

	// Create a new Intersection Observer
	const observer = new IntersectionObserver((entries, observer) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				const image = entry.target;

				// Set the "src" attribute with the value from "data-src"
				image.src = image.dataset.src;
				image.removeAttribute('data-src');

				// Animate the opacity of the image
				image.style.transition = 'all 0.15s';
				image.style.opacity = '0';
				image.onload = () => {
					image.style.opacity = '1';
					image.classList.add('lazy-loaded');
				};

				// Stop observing the current image
				observer.unobserve(image);
			}
		});
	}, config);

	// Start observing each image
	images.forEach((image) => {
		observer.observe(image);
	});
}
window.addEventListener('load', () => {
	lazyLoadImages();
	document.addEventListener('facetwp-loaded', lazyLoadImages);
	document.addEventListener('facetwp-refresh', lazyLoadImages);
});

function closeModal() {
	const html = document.querySelectorAll('html');
	const elements = document.querySelectorAll('.overlay, .close');
	var modal = document.querySelector('.modal');
	elements.forEach((el) => {
		el.addEventListener('click', (e) => {
			modal.classList.toggle('active');
			html[0].classList.toggle('lock-scroll');
			e.preventDefault();
			// toggleModal(modal);
		});
	});
}
window.addEventListener('DOMContentLoaded', closeModal);

// Function to check if the URL is a video link
function isVideoLink(url) {
	return (
		url.includes('mp4') ||
		url.includes('3gp') ||
		url.includes('ogg') ||
		url.includes('youtu') ||
		url.includes('vimeo')
	);
}

// Function to extract YouTube video ID from URL
function extractYouTubeVideoId(url) {
	var match = url.match(/v=([a-zA-Z0-9_-]+)/);
	if (match) {
		console.log(match[1]);
		return match[1];
	}
	return '';
}

// Function to extract Vimeo video ID from URL
function extractVimeoVideoId(url) {
	var match = url.match(/\/(\d+)/);
	if (match) {
		return match[1];
	}
	return '';
}

//
// Popup modal functionality
//
function popup_global() {
	var pop_up = script_vars.pop_up;
	// var page_popup = script_vars.page_popup;
	var current_page_id = script_vars.current_page_id;
	if (pop_up) {
		console.log('popup: on');
		var exclude_page_id = pop_up.exclude_page.ID;
	} else {
		console.log('popup: off');
		return;
	}

	// console.log(exclude_page_id);

	var popup_pestalert = document.querySelector('.popup-global');
	if (!popup_pestalert) {
		return;
	}

	var link = popup_pestalert.querySelector('a');
	if (!link) return;
	var close = popup_pestalert.querySelector('.popup-close');
	var cookie = getCookie('popup-global');

	if (parseInt(exclude_page_id) == parseInt(current_page_id)) {
		console.log('disable popup');
		return;
	} else {
		// check cookie
		if (cookie == null || cookie == 'false') {
			popup_pestalert.classList.add('active');
		} else {
			// return
		}

		// remove active class on popup
		close.addEventListener('click', (e) => {
			popup_pestalert.classList.remove('active');
			setCookie('popup-global', 'true', 5);
		});

		link.addEventListener('click', (e) => {
			setCookie('popup-global', 'true', 5);
			popup_pestalert.classList.remove('active');
		});

		function popupAction() {
			popup_pestalert.classList.remove('active');
			setCookie('popup-global', 'true', 5);
		}

		close.addEventListener('click', popupAction);
		link.addEventListener('click', popupAction);
	}
}
window.addEventListener('load', popup_global);

//
// Unique page popup /w contact form
//
// function popup_page() {
// 	var page_popup = script_vars.page_popup;
// 	if(page_popup) {
// 		var toggle = page_popup.toggle_popup;
// 		var contact_form_shortcode = page_popup.contact_form_shortcode;
// 		var popup_image = page_popup.popup_image.url;
// 		var url_parameter = page_popup.url_parameter;

// 		const parameterValue = getUrlParameter('origin');
// 		// console.log(parameterValue);
// 		// console.log(url_parameter);
// 		if(parameterValue == url_parameter) {
// 			openModal('.modal-page');
// 		}
// 	}
// }
// window.addEventListener('load', popup_page);
